import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const citationContainerStyle = css`
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing(2)};
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.floating};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  margin-top: ${theme.spacing(2)};
  border-left: 4px solid ${theme.colors.primary30};
  border-radius: ${theme.borderRadius.small};
  gap: ${theme.spacing(1)};
  width: 100%;
  margin-bottom: ${theme.spacing(2)};
  &:hover {
    box-shadow: ${theme.shadows.floating};
  }

  span {
    display: inherit;
    align-items: center;
    gap: ${theme.spacing(1)};
  }

  .message-citation {
    display: inherit;
    align-items: flex-end;
  }
`;

export const eggplantBorder = css`
  border-color: ${theme.colors.secondary.eggplant30};
`;

export const messageStyle = css`
  padding: ${theme.spacing(2)};
  background-color: ${theme.colors.neutral5};
  border-radius: ${theme.borderRadius.medium};
  text-align: left;
  flex: 1;
`;

export const alignRight = css`
  margin-left: auto;
`;

export const alignLeft = css`
  margin-right: auto;
`;

export const noCitationContainerStyle = css`
  border-left: 4px solid ${theme.colors.primary30};
  border-radius: ${theme.borderRadius.small};
  gap: ${theme.spacing(1)};
  box-shadow: ${theme.shadows.floating};
  padding: ${theme.spacing(2)};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${theme.spacing(2, 0)};
`;

export const reverseFlex = css`
  flex-direction: row-reverse;
`;
